import React from "react";
import { Breadcrumb } from "antd";

import { IconChevronRight } from "../../assets/index";

const BreadCrumbComponent = (props) => {
  return (
    <Breadcrumb separator={<IconChevronRight />}>
      {props?.breadCrumbs?.map((el, idx) => {
        if (el.isLink) {
          return (
            <Breadcrumb.Item href={el.link} key={idx.toString()}>
              {el.name}
            </Breadcrumb.Item>
          );
        }
        return (
          <Breadcrumb.Item key={idx.toString()}>{el.name}</Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default BreadCrumbComponent;
